import React, { useState, useEffect } from "react";
import Base from "../core/Base";
import { Link } from "react-router-dom";
import {
  getCategory,
  updateCateogry
} from "./helper/adminapicall";
import { isAutheticated } from "../auth/helper/index";

const UpdateCategory = ({ match }) => {
  const { user, token } = isAutheticated();

  const [values, setValues] = useState({
    name: "",
    formData : ""
    

  });

  const {
    name,
    formData

    
  } = values;

  const preload = categoryId => {
    getCategory(categoryId).then(data => {
        
     if(data.error){
          setValues({...values,error: data.error})
              } else {
       
        setValues({
          ...values,
          name: data.name,
          formData : new FormData()
        
        });
      }
    });
  };


  useEffect(() => {
    preload(match.params.categoryId);
  }, []);

  //TODO: work on it
  const onSubmit = event => {
    event.preventDefault();
    setValues({ ...values, error: "",});

    updateCateogry(match.params.categoryId, user._id, token,formData )
    .then(
      data => {
        if (data.error) {
          setValues({ ...values, error: data.error });
        } else {
          setValues({
            ...values,
            name: ""
        
          });
        }
      }
    );
  };

  const handleChange = name => event => {
    const value = name === "photo" ? event.target.files[0] : event.target.value;
    formData.set(name,value);
    setValues({ ...values, [name]: value });
  };


  const createProductForm = () => (
    <form>

     
      <div className="form-group">
        <input
          onChange={handleChange("name")}
          name="name"
          className="form-control"
          placeholder="Name"
          value={name}
        />
      </div>
     
    

      <button
        type="submit"
        onClick={onSubmit}
        className="btn btn-outline-success mb-3"
      >
        Update Product
      </button>
    </form>
  );

  return (
    <Base
      title="Manage Categories Here"
      description="Welcome to Cateogries section"
      className="container bg-info p-4"
    >
      <Link to="/admin/dashboard" className="btn btn-md btn-dark mb-3">
        Admin Home
      </Link>
      <div className="row bg-dark text-white rounded">
        <div className="col-md-8 offset-md-2">
          {createProductForm()}
        </div>
      </div>
    </Base>
  );
};

export default UpdateCategory;
